<div class="container mt-28">
  <div class="card w-full bg-transparent">
    <div class="child-card m-5 grid grid-rows-2">
      <form action="">
        <label for="codeOtp" class="font-bold">CodeOtp</label>
        <input [(ngModel)]="code" type="text" placeholder="1234" class="rounded form-control block w-full px-3 py-1 text-base font-normal text-gray-300 border border-solid border-blue-300 bg-transparent">
        <div class="button mt-3">
          <button (click)="doVerif()" class="btn btn-outline-primary">Verify</button>
        </div>
      </form>
      <div *ngIf="isSuccess" class="bg-blue-100 rounded-lg py-5 px-6  text-base text-blue-700 mb-3" role="alert">
       {{message}}
      </div>
  </div>

</div>
